import { render, staticRenderFns } from "./NichesContent.vue?vue&type=template&id=88ea0d4c&scoped=true"
import script from "./NichesContent.vue?vue&type=script&lang=js"
export * from "./NichesContent.vue?vue&type=script&lang=js"
import style0 from "./NichesContent.vue?vue&type=style&index=0&id=88ea0d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ea0d4c",
  null
  
)

export default component.exports